/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * 
 * @export
 * @interface WebApiMemberDtoGetMemberResultDto
 */
export interface WebApiMemberDtoGetMemberResultDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    uniqueId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    email2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    phone2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    adressRow2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    adressRow3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    personalNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    webPage?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    dateJoined?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    streetAdress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    postalArea?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    company?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    extra1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    extra2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    extra3?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    hasPaidCurrentYear?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    customFieldsJson?: string | null;
    /**
     * Optional invoice email (Fortnox EmailInvoice); empty = use Email.
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberResultDto
     */
    invoiceEmail?: string | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoGetMemberResultDto interface.
 */
export function instanceOfWebApiMemberDtoGetMemberResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoGetMemberResultDtoFromJSON(json: any): WebApiMemberDtoGetMemberResultDto {
    return WebApiMemberDtoGetMemberResultDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoGetMemberResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoGetMemberResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'email2': !exists(json, 'email2') ? undefined : json['email2'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'phone2': !exists(json, 'phone2') ? undefined : json['phone2'],
        'adressRow2': !exists(json, 'adressRow2') ? undefined : json['adressRow2'],
        'adressRow3': !exists(json, 'adressRow3') ? undefined : json['adressRow3'],
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
        'webPage': !exists(json, 'webPage') ? undefined : json['webPage'],
        'dateJoined': !exists(json, 'dateJoined') ? undefined : (json['dateJoined'] === null ? null : new Date(json['dateJoined'])),
        'streetAdress': !exists(json, 'streetAdress') ? undefined : json['streetAdress'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'postalArea': !exists(json, 'postalArea') ? undefined : json['postalArea'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'extra1': !exists(json, 'extra1') ? undefined : json['extra1'],
        'extra2': !exists(json, 'extra2') ? undefined : json['extra2'],
        'extra3': !exists(json, 'extra3') ? undefined : json['extra3'],
        'hasPaidCurrentYear': !exists(json, 'hasPaidCurrentYear') ? undefined : json['hasPaidCurrentYear'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'customFieldsJson': !exists(json, 'customFieldsJson') ? undefined : json['customFieldsJson'],
        'invoiceEmail': !exists(json, 'invoiceEmail') ? undefined : json['invoiceEmail'],
    };
}

export function WebApiMemberDtoGetMemberResultDtoToJSON(value?: WebApiMemberDtoGetMemberResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uniqueId': value.uniqueId,
        'email': value.email,
        'email2': value.email2,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
        'phone2': value.phone2,
        'adressRow2': value.adressRow2,
        'adressRow3': value.adressRow3,
        'personalNumber': value.personalNumber,
        'webPage': value.webPage,
        'dateJoined': value.dateJoined === undefined ? undefined : (value.dateJoined === null ? null : value.dateJoined.toISOString().substr(0,10)),
        'streetAdress': value.streetAdress,
        'postalCode': value.postalCode,
        'postalArea': value.postalArea,
        'title': value.title,
        'country': value.country,
        'company': value.company,
        'extra1': value.extra1,
        'extra2': value.extra2,
        'extra3': value.extra3,
        'hasPaidCurrentYear': value.hasPaidCurrentYear,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'customFieldsJson': value.customFieldsJson,
        'invoiceEmail': value.invoiceEmail,
    };
}

